module.exports = __webpack_public_path__ + "static/media/IMG_0796.d802039b.JPG";